import React from "react";
import "./more.less";
import { useAuth } from "../../../../context/authContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const invitCard1 = new URL("../../../../assets/reitCard1.png", import.meta.url)
  .href;
const invitCard2 = new URL("../../../../assets/reitCard2.png", import.meta.url)
  .href;

const MoreInvits: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleProtectedClick = () => {
    if (!isAuthenticated) {
      toast.error("You need to login first!");
      return false;
    }
    return true;
  };

  const handleFinancialClick = () => navigate("/invits/financial-compare");
  const handleOperationalClick = () => navigate("/invits/operational-compare");

  return (
    <section className="more-invits-section">
      <div className="more-invits">
        {/* Compare Section */}
        <div className="more-invits__compare">
          <div className="more-invits__card">
            <img
              src={invitCard1}
              alt="Compare InvIT Properties"
              className="more-invits__card-img"
            />
            <h3 className="more-invits__card-title">
              Compare InvITs Financial Metrics
            </h3>
            <p className="more-invits__card-desc">
              Dive deep into financial ratios, market cap, and performance
              across InvITs.
            </p>
            <button
              className="more-invits__card-btn"
              onClick={() => {
                if (handleProtectedClick()) {
                  handleFinancialClick();
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
          </div>

          <div className="more-invits__card">
            <img
              src={invitCard2}
              alt="Compare InvITs"
              className="more-invits__card-img"
            />
            <h3 className="more-invits__card-title">
              Compare InvITs Operational Metrics
            </h3>
            <p className="more-invits__card-desc">
              Analyze project performance, operations, and unique project
              counts.
            </p>
            <button
              className="more-invits__card-btn"
              onClick={() => {
                if (handleProtectedClick()) {
                  handleOperationalClick();
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MoreInvits;
